import React from "react";
import { CircularProgress, Box } from "@mui/material";

const Loader = () => {
  return (
    <Box display="flex" justifyContent="center" alignItems="center" m={"auto"}>
      <CircularProgress sx={{ color: "orange" }} />
    </Box>
  );
};

export default Loader;
